import React, { Component } from "react";
import TopHeader from "../template/TopHeader";
import { connect } from "react-redux";
import ClientsTopNav from "./ClientsTopNav";
import Lottie from "react-lottie";
import animationData from "../../assets/animation-data/loader.json";
import axios from 'axios';
import API from "../../config/API";
// Errors only: a switch only moves once its save lands, so success needs no toast.
import toast from '../shared/Toast';
import ShareBookedClientsSetting from './ShareBookedClientsSetting';
import "./Clients.css";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

class DataSharing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isSalonOwner: false,
      isSelfEmployed: false,
      sharingSettings: [],
      mySettings: null,
      // From the booking setting: words each stylist's line.
      bookShares: true,
      businessName: '',
    };
  }

  componentDidMount() {
    this.loadSharingSettings();
  }

  loadSharingSettings = async () => {
    try {
      this.setState({ loading: true });

      const user = this.props.user?.userInfo ||
                   this.props.authentication?.user ||
                   JSON.parse(localStorage.getItem('user'));

      const isSalonOwner = user?.hairdresser?.isSalonOwner === 1 ||
                          user?.hairdresserInfo?.isSalonOwner === 1;
      const isSelfEmployed = user?.hairdresser?.employmentTypeId === 2 ||
                            user?.hairdresserInfo?.employmentTypeId === 2;

      this.setState({ isSalonOwner, isSelfEmployed });

      if (isSalonOwner) {
        const response = await axios.get(API.HAIRDRESSER_SHARING_SETTINGS, {
          headers: {
            'Content-Type': 'application/json',
            'accessToken': localStorage.getItem('accessToken'),
          }
        });

        if (response.data && response.data.responseData && response.data.responseData.data) {
          const settings = response.data.responseData.data;
          const mySettings = settings.find(s => s.hairdresserId === user?.hairdresser?._id || s.hairdresserId === user?.hairdresserInfo?._id);

          this.setState({
            sharingSettings: settings,
            mySettings: mySettings,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      } else if (isSelfEmployed) {
        const response = await axios.get(API.HAIRDRESSER_SHARING_SETTINGS, {
          headers: {
            'Content-Type': 'application/json',
            'accessToken': localStorage.getItem('accessToken'),
          }
        }).catch(error => {
          console.log('SE user - using local data');
          return null;
        });

        let mySettings;
        if (response && response.data && response.data.responseData && response.data.responseData.data) {
          const settings = response.data.responseData.data;
          mySettings = settings.find(s => s.hairdresserId === user?.hairdresser?._id || s.hairdresserId === user?.hairdresserInfo?._id);
        } else {
          mySettings = {
            hairdresserId: user?.hairdresser?._id || user?.hairdresserInfo?._id,
            name: user?.name || 'You',
            employmentType: 'self_employed',
            clientShare: user?.hairdresser?.clientShare || user?.hairdresserInfo?.clientShare || 0,
            salonClientAccess: user?.hairdresser?.salonClientAccess || user?.hairdresserInfo?.salonClientAccess || 0
          };
        }

        this.setState({
          mySettings: mySettings,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Error loading sharing settings:", error);
      this.setState({ loading: false });
    }
  };

  handleUpdateSalonAccess = async (hairdresserId, salonClientAccess) => {
    try {
      const response = await axios.put(API.HAIRDRESSER_SALON_CLIENT_ACCESS,
        { hairdresserId, salonClientAccess },
        {
          headers: {
            'Content-Type': 'application/json',
            'accessToken': localStorage.getItem('accessToken'),
          }
        }
      );

      if (response.data && response.data.responseData) {
        this.setState(prevState => ({
          sharingSettings: prevState.sharingSettings.map(s =>
            s.hairdresserId === hairdresserId
              ? { ...s, salonClientAccess: salonClientAccess ? 1 : 0 }
              : s
          )
        }));
      }
    } catch (error) {
      console.error("Error updating salon access:", error);
      toast.error("That didn’t save. Try again in a moment.");
    }
  };

  handleBulkUpdateSalonAccess = async (salonClientAccess) => {
    try {
      const response = await axios.put(API.HAIRDRESSER_SALON_CLIENT_ACCESS_BULK,
        { salonClientAccess },
        {
          headers: {
            'Content-Type': 'application/json',
            'accessToken': localStorage.getItem('accessToken'),
          }
        }
      );

      if (response.data && response.data.responseData) {
        this.setState(prevState => ({
          sharingSettings: prevState.sharingSettings.map(s =>
            s.employmentType === 'self_employed'
              ? { ...s, salonClientAccess: salonClientAccess ? 1 : 0 }
              : s
          )
        }));
      }
    } catch (error) {
      console.error("Error bulk updating salon access:", error);
      toast.error("That didn’t save. Try again in a moment.");
    }
  };

  // What a stylist without all-client access sees, in plain words.
  accessHint = (staff) => {
    if (staff.salonClientAccess === 1) return 'Can find and book any of your clients';
    const n = Number(staff.sharedClientCount) || 0;
    if (n > 0) return `Sees only the ${n === 1 ? 'client' : `${n} clients`} on their list`;
    return this.state.bookShares ? 'Sees only clients you book with them' : 'Sees none of your clients';
  };

  areAllSEEnabled = () => {
    const { sharingSettings } = this.state;
    const selfEmployedStaff = sharingSettings.filter(s => s.employmentType === 'self_employed');
    if (selfEmployedStaff.length === 0) return false;
    return selfEmployedStaff.every(s => s.salonClientAccess === 1);
  };

  handleUpdateMySharing = async (clientShare) => {
    try {
      const response = await axios.put(API.HAIRDRESSER_CLIENT_SHARING,
        { clientShare: clientShare ? 1 : 0 },
        {
          headers: {
            'Content-Type': 'application/json',
            'accessToken': localStorage.getItem('accessToken'),
          }
        }
      );

      if (response.data && response.data.responseData) {
        this.setState(prevState => ({
          mySettings: { ...prevState.mySettings, clientShare: clientShare ? 1 : 0 }
        }));
      }
    } catch (error) {
      console.error("Error updating sharing:", error);
      toast.error("That didn’t save. Try again in a moment.");
    }
  };

  renderToggle(checked, onChange, disabled) {
    return (
      <button
        type="button"
        className={'ds-toggle' + (checked ? ' ds-toggle--on' : '') + (disabled ? ' ds-toggle--disabled' : '')}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
      >
        <span className="ds-toggle-knob" />
      </button>
    );
  }

  renderSalonOwnerView = () => {
    const { sharingSettings } = this.state;
    const selfEmployedStaff = sharingSettings.filter(s => s.employmentType === 'self_employed');

    if (selfEmployedStaff.length === 0) {
      return (
        <div className="ds-empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <line x1="17" y1="11" x2="23" y2="11" />
          </svg>
          <p>No self-employed team members in your business</p>
        </div>
      );
    }

    const allEnabled = this.areAllSEEnabled();

    return (
      <>
        <div className="ds-intro">
          <div className="ds-intro-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
          </div>
          <h3 className="ds-intro-title">Who sees which clients</h3>
          <p className="ds-intro-desc">
            Choose which of your clients each self-employed stylist can see. Their own clients are theirs, and they choose whether you see them.
          </p>
        </div>

        <ShareBookedClientsSetting onChange={({ on, businessName }) => this.setState({ bookShares: on, businessName })} />

        <div className="ds-bulk-card">
          <div className="ds-bulk-text">
            <span className="ds-bulk-title">Let every self-employed stylist see all your clients</span>
            <span className="ds-bulk-desc">They can find and book any of your clients.</span>
          </div>
          {this.renderToggle(allEnabled, (val) => this.handleBulkUpdateSalonAccess(val))}
        </div>

        <div className="ds-section-title">Self-employed stylists</div>

        <div className="ds-staff-list">
          {selfEmployedStaff.map((staff) => {
            const initials = (staff.name || '').split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
            return (
              <div className="ds-staff-row" key={staff.hairdresserId}>
                <div className="ds-staff-avatar">{initials}</div>
                <div className="ds-staff-info">
                  <span className="ds-staff-name">{staff.name}</span>
                  <div className="ds-staff-toggles">
                    <div className="ds-staff-toggle-item">
                      <div className="ds-toggle-text">
                        <span className="ds-toggle-label">Sees all your clients</span>
                        <span className="ds-toggle-hint">{this.accessHint(staff)}</span>
                      </div>
                      {this.renderToggle(
                        staff.salonClientAccess === 1,
                        (val) => this.handleUpdateSalonAccess(staff.hairdresserId, val)
                      )}
                    </div>
                    {/* Their choice, not yours: a fact, not a switch. */}
                    <div className="ds-staff-toggle-item">
                      <div className="ds-toggle-text">
                        <span className="ds-toggle-label">Their own clients</span>
                        <span className="ds-toggle-hint">Their choice</span>
                      </div>
                      <span className={'ds-chip' + (staff.clientShare === 1 ? ' ds-chip--on' : '')}>
                        {staff.clientShare === 1 ? 'You can see them' : 'Private'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <p className="ds-footnote">
          If a self-employed stylist leaves, they take their own clients and a copy of the clients on their list. {this.state.businessName || 'Your business'} keeps all of its clients.
        </p>
      </>
    );
  };

  renderSelfEmployedView = () => {
    const { mySettings } = this.state;

    if (!mySettings) {
      return (
        <div className="ds-empty">
          <p>Unable to load your settings</p>
        </div>
      );
    }

    return (
      <>
        <div className="ds-intro">
          <div className="ds-intro-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
          </div>
          <h3 className="ds-intro-title">Client sharing</h3>
          <p className="ds-intro-desc">
            Sharing lets the business and other team members see your clients, so they can help with bookings when you're unavailable. You control whether to share your own clients below.
          </p>
        </div>

        <div className="ds-se-cards">
          <div className="ds-se-card">
            <div className="ds-se-card-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              <span>Business client access</span>
            </div>
            <p className="ds-se-card-desc">
              {mySettings.salonClientAccess === 1
                ? "The business has given you access to their client list. You can view and book their clients."
                : "The business has not shared their client list with you. Ask your business manager to enable this."}
            </p>
            <div className="ds-se-card-toggle">
              {this.renderToggle(mySettings.salonClientAccess === 1, () => {}, true)}
              <span className={'ds-se-status' + (mySettings.salonClientAccess === 1 ? ' ds-se-status--on' : '')}>{mySettings.salonClientAccess === 1 ? 'Access granted' : 'No access'}</span>
            </div>
            <span className="ds-se-card-note">Controlled by the business manager</span>
          </div>

          <div className="ds-se-card">
            <div className="ds-se-card-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="18" cy="5" r="3" />
                <circle cx="6" cy="12" r="3" />
                <circle cx="18" cy="19" r="3" />
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
              </svg>
              <span>Share my clients</span>
            </div>
            <p className="ds-se-card-desc">
              {mySettings.clientShare === 1
                ? "Your client list is visible to the business. They can view your clients and make bookings for them when you're not available."
                : "Your client list is private. Turn this on to let the business see your clients and help with bookings when you're unavailable."}
            </p>
            <div className="ds-se-card-toggle">
              {this.renderToggle(mySettings.clientShare === 1, (val) => this.handleUpdateMySharing(val))}
              <span className={'ds-se-status' + (mySettings.clientShare === 1 ? ' ds-se-status--on' : '')}>{mySettings.clientShare === 1 ? 'Sharing' : 'Private'}</span>
            </div>
          </div>
        </div>
      </>
    );
  };

  renderEmployedView = () => {
    return (
      <>
      {/* Someone allowed to change salon settings can still set this. */}
      <ShareBookedClientsSetting />
      <div className="ds-empty">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <p>Client sharing is managed by your business owner. As an employed team member, you already have access to the business client list.</p>
      </div>
      </>
    );
  };

  render() {
    const { loading, isSalonOwner, isSelfEmployed } = this.state;

    const body = (
      <div className="ds-container">
        {loading ? (
          <div className="ds-loading">
            <Lottie options={defaultOptions} height={80} width={80} />
          </div>
        ) : isSalonOwner ? (
          this.renderSalonOwnerView()
        ) : isSelfEmployed ? (
          this.renderSelfEmployedView()
        ) : (
          this.renderEmployedView()
        )}
      </div>
    );

    // Settings › Sharing shows this as its Clients tab, inside its own page.
    if (this.props.embedded) return body;

    return (
      <div className="h_n catalogue-no-header">
        <div className="body_container cm_bg_white">
          <TopHeader title="Clients" headerButtonStatus={false} {...this.props} />
          <div className="catalogue-page-wrapper">
            <ClientsTopNav activeTab="dataSharing" onTabChange={(tab) => {
              if (tab === 'clientList') this.props.history.push('/clients');
            }} />
            <div className="catalogue-content-container">
              {body}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};

export default connect(mapStateToProps)(DataSharing);
